import { render, staticRenderFns } from "./withdrawal-list.vue?vue&type=template&id=4ba13c89&scoped=true"
import script from "./withdrawal-list.vue?vue&type=script&lang=js"
export * from "./withdrawal-list.vue?vue&type=script&lang=js"
import style0 from "./withdrawal-list.vue?vue&type=style&index=0&id=4ba13c89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba13c89",
  null
  
)

export default component.exports